
// 社交圈页面——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `page/socialCircle/index${i + 1}`,
  name: `page/socialCircleIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/socialCircle/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 社交圈页面——主流程，开始
    ...MainRoutes
  ]
}
